





































import Carousel from '../components/Carousel.vue'
import mixins from 'vue-typed-mixins'
import Section from '@/builder/sections/mixins/Section'
export default mixins(Section).extend({
  name: 'Gallery3',
  components: { Carousel }
})
